import React from "react";
import { Link } from "react-router-dom";
import { cap } from "@/components/afspraken/afsprakenUtils";

// v19-C2/C3: één afspraak van de afdeling, compact (Vandaag) of als kopregel (Afspraken).
export const AfdelingAfspraakRegel = ({ a, testid, naar = true }) => {
  const inhoud = (
    <>
      <span className="block text-[13.5px] text-zinc-900">{a.wat}</span>
      <span className="block text-xs text-zinc-500 mt-0.5">
        {a.locatie || "Algemeen"} · door {cap(a.door)}{" · "}
        <span className={a.dagenTeLaat > 0 ? "text-rose-600 font-bold" : ""}>{a.volgendeLabel || "geen deadline"}{a.dagenTeLaat > 0 ? ` · ${a.dagenTeLaat} ${a.dagenTeLaat === 1 ? "dag" : "dagen"} te laat` : ""}</span>
      </span>
      {a.werkbon && <span data-testid={`${testid}-werkbon`} className="inline-block mt-1 font-mono text-[11px] px-1.5 py-0.5 rounded bg-zinc-100 border border-zinc-200 text-zinc-700">Werkbon {a.werkbon}</span>}
    </>
  );
  return naar ? <Link to={`/afspraken?select=${a.id}`} data-testid={testid} className="block px-3 py-2.5 hover:bg-zinc-50">{inhoud}</Link>
    : <div data-testid={testid} className="px-3 py-2.5">{inhoud}</div>;
};
